/* unplugin-vue-components disabled */import script from "./GateButtonConfirmation.vue?vue&type=script&lang=ts&setup=true"
export * from "./GateButtonConfirmation.vue?vue&type=script&lang=ts&setup=true"

import "./GateButtonConfirmation.vue?vue&type=style&index=0&id=561f3942&lang=scss"

const __exports__ = script;

export default __exports__